import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';

import '../ui/css/PrivacyPpolicy.css';

const PrivacyPpolicy = () => {
  const hostname = window.location.hostname;
  const prefix = hostname.split('.')[0];
  const [headerHeight, setHeaderHeight] = useState(0);
  const mainWrapperRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('.header');
      if (header instanceof HTMLElement) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeaderHeight();
    const timeoutId = setTimeout(updateHeaderHeight, 0);

    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);

  function offset(el: Element) {
    var rect = el.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop };
  }

  const scrollHeight = useMemo(() => {
    const tableOffset =
      mainWrapperRef.current instanceof HTMLElement
        ? offset(mainWrapperRef.current).top
        : 0;
      
    return `calc(100vh - ${
      tableOffset > 0 ? tableOffset : headerHeight
    }px)`;
  }, [headerHeight]);
  

  return (
    <div ref={mainWrapperRef} className="main-wrapper" style={{width: '100vw', height: scrollHeight}}>
      <div
        className="scrollable-container"
        id="tags-scroll"
        style={{
          width: '100%',
          height: 'fit-content',
          maxHeight: '100%',
          overflow: 'auto'
        }}
      >
        <div
          className="flex flex-column scrollable-content"
          style={{ width: '99%' }}
        >

          <article style={{margin:'0 auto', width: '80%', height: 'fit-content'}}>
            <h1>Политика конфиденциальности (условия обработки информации о пользователях)</h1>
            <h2>1. Сфера и предмет регулирования</h2>
            <p>Настоящие Условия защиты информации о пользователях (далее – Условия) являются официальным документом Публичного
        акционерного общества «Ростелеком» (далее – ПАО «Ростелеком», Оператор) и разработан и исполняется Оператором в
        отношении программ для ЭВМ (мобильных приложений), функционирующих под управлением Android, iOS и других
        операционных систем, а также продуктов, услуг, сервисов, предоставляемых Оператором при помощи таких мобильных
        приложений (далее – «мобильные приложения» или «сервисы»). Данные Условия определяют условия и цели сбора,
        хранения, защиты, обработки, предоставления и распространения информации о пользователях мобильных приложений
        Ростелекома.</p>
            <p>Адрес и контакты ПАО «Ростелеком»:</p>
            <p>Адрес местонахождения (юридический адрес): Российская Федерация, 191002, г. Санкт-Петербург, ул. Достоевского,
        д.15.</p>
            <p>Почтовый адрес: Российская Федерация, 115172, г. Москва, ул. Гончарная, д. 30, стр. 1</p>
            <p>Телефон: +7 (499) 999-82-83.</p>
            <h2>2. Виды информации</h2>
            <p>В соответствии с настоящими Условиями к информации о пользователях относятся:</p>
            <ol>
              <li>стандартные данные, автоматически получаемые http-сервером при доступе к сервису (ip-адрес хоста, адрес
          запрошенного ресурса, время, тип и информация о мобильном устройстве, пославшей запрос ресурса, вид операционной
          системы пользователя, заголовок, содержащий идентификатор сессии для авторизованного пользователя);
              </li>
              <li>данные электронных форм, заполняемых и направляемых Оператору по инициативе пользователей при регистрации в
          мобильном приложении (профили пользователей – включая, без ограничения: имена пользователей, логины, пароли,
          имена и фамилии пользователей,
              </li>
              <li>информация о геолокации пользователя в фоновом режиме работы приложения;
              </li>
            </ol>
            <p>Для целей исполнения настоящих Условий и обеспечения дополнительной защиты пользователей, предусмотренные
        Условиями режим защиты персональных данных, распространяется на адреса электронной почты, ICQ, Odigo, IRC,
        телефонные номера и почтовые адреса.
            </p>
            <p>Вся собранная, хранящаяся и обработанная Оператором информация о пользователях считается информацией
        ограниченного доступа, если иное не установлено законодательством Российской Федерации или настоящими Условиями.
            </p>
            <h2>3. Применимое законодательство</h2>
            <p>Рассматриваемые настоящими Условиями отношения, связанные со сбором, хранением, обработкой, распространением и
        защитой информации о пользователях мобильного приложения, регулируются в соответствии с действующим
        законодательством Российской Федерации. Применение к ним норм иностранного права возможно исключительно в случаях,
        предусмотренных законодательством Российской Федерации и имеющими силу для Российской Федерации международными
        соглашениями.
            </p>
            <h2>4. Статус Условий и официальных документов Оператора
            </h2>
            <p>Официальными документами Оператора, определяющими условия использования отдельных мобильных приложений, включая
        совместные партнерские проекты и сервисы Оператора, могут быть определены дополнительные условия, состав и порядок
        сбора, хранения, защиты, обработки и распространения информации о пользователях.
        Настоящие Условия имеют приоритет над вышеназванными документами и регламентами, которые применяются только в том
        случае, если не противоречат настоящим Условиям и при условии, что указанными документами и регламентами явно не
        указано, что их положения в отношении защиты информации пользователей имеют преимущественную силу.</p>
            <h2>5. Условия пользования мобильным приложениям и согласие пользователя
            </h2>
            <p>Оператор исходит из того, что пользователь, инициирующий обращение к мобильному приложению:
            </p>
            <ol>
              <li>сознательно использует мобильное приложение от своего имени и достоверно указывает информацию о себе в объеме
          и в случаях, когда это требуется при регистрации, доступе и использовании мобильного приложения;
              </li>
              <li>сознательно определил и контролирует настройки используемого им программного обеспечения в соответствии со
          своими предпочтениями относительно защиты информации, персональных данных, информации о собственном
          аппаратно-программном обеспечении и интернет-соединении;
              </li>
              <li>имеет возможность ознакомиться с правилами и протоколами информационного обмена, закрепленными в открытых
          стандартах Интернета (rfc-editor.org);
              </li>
              <li>ознакомился и имеет возможность в любой момент ознакомиться с настоящими Условиями путем перехода по
          гипертекстовой ссылке «Условия» со страницы приложения в Google Play Market, с условиями использования
          соответствующих сервисов Оператора, а также с использованием требуемых разрешений в мобильном приложении;
              </li>
            </ol>
            <p>
        При регистрации и доступе к мобильным приложением пользователю запрещается указывать о себе недостоверную и/или
        неполную информацию. Пользователь самостоятельно несет риски наступления любых неблагоприятных последствий в
        случаях предоставления чужих и (или) недостоверных персональных данных.
        Оператор считает, что пользователь, регистрируясь и осуществляя доступ к мобильному приложению, ознакомлен с
        настоящими Условиями, выражает свое согласие с ними и принимает на себя указанные в них права и обязанности.
        Согласие пользователей мобильного приложения осуществляется в форме и на условиях, установленных настоящими
        Условиями.
        В случае несогласия пользователя с настоящими Условиями использование мобильного приложения должно быть
        прекращено.
            </p>
            <p>
        Заполняя размещенную в мобильном приложении регистрационную форму и предоставляя свои персональные данные
        Оператору, пользователь подтверждает, что он достиг возраста 18 лет и что он принимает настоящие Условия и дает
        согласие на обработку своих персональных данных Оператору в соответствии с настоящими Условиями.
            </p>
            <p>
        Согласие, предоставляемое пользователем при регистрации и сообщении своих персональных данных и персональных
        данных третьих лиц Оператору, также распространяется на передачу таких данных Оператором иным лицам в целях
        обеспечения возможности использования мобильного приложения согласно его назначению, в т.ч. для целей поддержания
        работоспособности мобильного приложения, анализа информации о его использовании, а также осуществления действий
        направленных на подключение пользователя к услугам Оператора, включая заключение от имени Оператора договора о
        предоставлении услуг Оператора.
        Оператор исходит из того, что регистрационную форму в мобильном приложении заполняет непосредственно сам
        пользователь. Ответственность за правомерность предоставления и достоверность персональных данных пользователя и
        иных лиц, данные которых сообщены, несет исключительно пользователь. Поскольку Оператор не проводит установление
        личности пользователя и не принимает на себя обязанности по такому установлению личности, Оператор не отвечает за
        то, что пользователь действительно является тем лицом, от имени которого осуществлена регистрация и/или
        использование мобильного приложения, и не несет ответственности за возможный ущерб, причиненный другим
        пользователям или иным лицам в случае, если пользователь не является таким лицом.
        Оператор не принимает на себя никаких обязательств по проверке достоверности персональных данных, указанных
        пользователем, и не несет ответственности в случае, если пользователь предоставит больший объем данных, чем это
        предусмотрено размещенной в мобильном приложении регистрационной формой и целями обработки персональных данных, в
        том числе специальные категории персональных данных. Предоставляя персональные данные в объеме большем, чем это
        предусмотрено регистрационной формой и целями обработки персональных данных, пользователь выражает свое согласие
        на обработку таких персональных данных Оператором.
        Предусматривается смешанная обработка персональных данных пользователей и иных лиц, персональные данные которых
        указаны при регистрации и использовании мобильного приложения, то есть как обработка без использования средств
        автоматизации, так и автоматизированная обработка с передачей полученной информации с использованием сети
        Интернет.
        Настоящее согласие предоставляется на весь период использования мобильного приложения согласно его назначению, а
        также 3 (трех) лет после прекращения такого использования, если иное не предусмотрено законодательством РФ.
            </p>
            <p>
        Пользователь осведомлен, что может отозвать согласие на обработку персональных данных, направив Оператору
        заявление в бумажной или в электронной форме, в том числе с использованием своего аккаунта (учетной записи) в
        мобильном приложении с указанием в таком заявлении данных, предусмотренных Федеральным законом от 27.07.2006 №
        152-ФЗ «О персональных данных».
        В случае получения отзыва согласия пользователя на обработку персональных данных в бумажной форме Оператор в целях
        идентификации субъекта персональных данных вправе запросить у такого лица дополнительные сведения, предоставленные
        субъектом персональных данных при регистрации в мобильном приложении, либо попросить такое лицо направить
        электронный запрос на отзыв согласия на обработку персональных данных через соответствующий аккаунт (учетную
        запись) субъекта персональных данных в мобильном приложении
        В случае невыполнения обратившимся лицом таких дополнительных действий Оператор вправе отказать такому лицу в
        отзыве согласия на обработку персональных данных в целях защиты прав третьих лиц.
        В случае отзыва ранее выданного согласия на обработку персональных данных пользователем или третьими лицами,
        персональные данные которых были получены Оператором от пользователя, указанные субъекты не смогут воспользоваться
        мобильным приложением и предоставляемыми с его помощью возможностями.
            </p>
            <p>
        Оператор вправе продолжить обработку персональных данных пользователя после отзыва им своего согласия в случаях,
        предусмотренных законодательством Российской Федерации.
        При этом пользователь уведомлен, что несет установленную законодательством РФ ответственность в случае указания
        некорректных контактных данных, а также данных третьих лиц без получения соответствующих полномочий от них.
            </p>
            <h2>6. Сбор и обработка информации о пользователях</h2>
            <p>Оператор осуществляет сбор и обработку информации о пользователях в соответствии с настоящими Условиями и иными
        официальными документами Оператора, определяющими условия использования соответствующих сервисов, в целях
        исполнения своих обязанностей, установленных указанными документами, в т.ч. в целях предоставления функциональных
        возможностей, услуг и т.п., предусмотренных соответствующими сервисами и запрошенными пользователями.
        Оператором осуществляются следующие действия с персональными данными пользователя: сбор, запись, накопление,
        хранение, извлечение, использование, удаление, уничтожение, автоматизированная и ручная обработка (в случае, когда
        это требуется для предоставления услуги или консультации пользователю), Оператор имеет право обрабатывать
        информацию о пользователях, полученную в результате обмена информацией с третьими лицами по протоколам OpenID и
        OAuth, при условии что указанные третьи лица получат предварительное согласие пользователей на указанную
        обработку.
            </p>
            <h2>7. Ограничение получения информации от и о несовершеннолетних</h2>
            <p>Оператор не имеет намерения получать информацию от несовершеннолетних и рекомендует законным представителям
        несовершеннолетних допускать их к работе в сети Интернет только под собственным контролем законным представителям.
        Оператор использует информацию о пользователях в целях защиты прав несовершеннолетних в рамках и пределах,
        установленных действующим законодательством.</p>
            <h2>8. Ограничение ответственности за достоверность получаемой информации</h2>
            <p>Оператор не проверяет достоверность получаемой информации о пользователях и не осуществляет контроль за
        правосубъектностью пользователей.</p>
            <h2>9. Хранение информации о пользователях</h2>
            <p>Оператор осуществляет хранение информации о пользователях в соответствии с настоящими условиями.
            </p>
            <h2>10. Защита информации
            </h2>
            <p>Оператор предпринимает все разумные меры по защите информации о пользователях от уничтожения, искажения или
        разглашения.
            </p>
            <p>Оператор обеспечивает конфиденциальность соответствующей информации в пределах и на условиях, установленных
        действующим законодательством Российской Федерации и настоящим Условиями.
            </p>
            <h2>11. Доступ к информации о пользователях
            </h2>
            <p>Помимо Оператора, доступ к информации о пользователях, при условии соблюдения требований законодательства
        Российской Федерации имеют:</p>
            <ol>
              <li>лица, права и обязанности которых по доступу к соответствующей информации установлены федеральными законами
          Российской Федерации;
              </li>
              <li>пользователи сервисов – в части доступа к информации, идентифицирующей их личность (персональные данные
          пользователей), по указанному ими при регистрации паролю и логину;
              </li>
              <li>партнеры Оператора в отношении совместных партнерских проектов и сервисов Оператора в пределах и на условиях,
          устанавливаемых соответствующими официальными документами, определяющих их использование;
              </li>
              <li>пользователи проектов и сервисов Оператора в пределах и на условиях, устанавливаемых соответствующими
          официальными документами Ростелекома, определяющих их использование;
              </li>
              <li>лица и организации, осуществляющие техническую поддержку служб и сервисов Оператора в объеме, необходимом для
          осуществления такой технической поддержки, при условии соблюдения ими конфиденциальности информации о
          пользователях;
              </li>
              <li>лица, обратившиеся к Оператору в соответствии с Регламентом по рассмотрению жалоб и блокированию незаконного
          контента, при условии наличия заявления пользователя о несогласии с блокированием спорного (незаконного)
          контента.
              </li>
            </ol>
            <h2>12. Права пользователя в отношении информации</h2>
            <p>Оператор гарантирует соблюдение следующих прав пользователя мобильного приложения:</p>
            <ol>
              <li>право на получение сведений о том, осуществляется ли Оператором обработка информации, позволяющей
          идентифицировать личность пользователя (персональные данные);
              </li>
              <li>право на удаление обрабатываемых персональных данных;</li>
              <li>право на редактирование, уточнение или исправление обрабатываемых персональных данных при условии соблюдения
          требований настоящих Условий.
              </li>
            </ol>
            <p>Удаление персональных данных происходит в течение 3 (трех) рабочих дней со дня поступления соответствующего
        запроса пользователя и может повлечь невозможность использования последним соответствующихсервисов.</p>
            <p>Оператор вправе удалить информацию о пользователе в случае нарушения последним норм официальных документов
        Оператора, в том числе, определяющих условия использования отдельных сервисов.
            </p>
            <p>Если таковая возможность предусмотрена, сервисов имеет право разрешить или запретить предоставление информации о
        себе партнерам Оператора или третьим лицам по протоколам OpenID и OAuth. Оператор обязуется в соответствующих
        официальных документах, определяющих правила использования сервисов Оператора, указывать лиц, которым будет
        предоставлена данная информация, и условия указанного волеизъявления пользователя в отношении использования
        информации в рамках указанных протоколов.
            </p>
            <p>Пользователь имеет право распространять собственные персональные данные любыми законными способами. Оператор не
        несет ответственности за действия третьих лиц, которые получили доступ к информации о пользователях в результате
        указанного распространения, либо осуществили неправомерный доступ к охраняемой информации о пользователях.
            </p>
            <h2>13. Ограничение распространения и предоставления информации о пользователях</h2>
            <p>Оператор распространяет и/или предоставляет информацию о пользователях исключительно в следующих случаях:
            </p>
            <ol>
              <li>после обработки соответствующей информации (деперсонификации информации), повлекшей удаление сведений (включая
          адреса электронной почты), позволяющих идентифицировать личность пользователя, а также после статистической
          обработки информации;
              </li>
              <li>с разрешения лиц, предоставивших Оператору при регистрации на соответствующих ресурсах Ростелекома собственные
          профили;
              </li>
              <li>предоставление информации лицам, указанным в п. 11 настоящих Условий.
              </li>
            </ol>
            <h2>14. Ограничение использования информации из профилей пользователей
            </h2>
            <p>В случае, если пользователю стали известны логин и пароль другого пользователя, а также иная конфиденциальная
        информация о последнем, он обязан уведомить об этом Оператора и не использовать ставшую известной ему указанную
        информацию.
            </p>
            <p>Информация из профилей пользователей не используется Оператором для рассылки пользователям любой информации, за
        исключением случаев, предусмотренных правилами (регламентами) использования соответствующих сервисов, или по их
        явному запросу.
            </p>
            <h2>15. Использование информации, хранящейся на стороне мобильного приложения
            </h2>
            <p>Оператор использует информацию, хранящуюся на стороне мобильного приложения, в соответствии с целями,
        определенными настоящими Условиями, для определения уникального идентификатора доступа пользователя к сервисам,
        для следующих целей:
            </p>
            <ol>
              <li>поддержки функционирования ресурсов, требующих использования информации, хранящейся на стороне мобильного
          приложения;
              </li>
              <li>определения статистических информационных предпочтений пользователей при доступе к различным сервисам;
              </li>
              <li>определения в исследовательских целях корреляции статистических данных об использовании мобильного приложения
          с данными о пользователях Оператора.
              </li>
              <li>Определения текущей геопозиции пользователя и оптимизации построения маршрутов до клиентов Оператора;
              </li>
            </ol>
            <p>Путем настройки программного обеспечения пользователь имеет возможность запретить использование информации,
        хранящейся мобильном приложении, однако это может привести к частичной или полной потере функциональности
        сервисов.
        Оператор вправе предоставлять соответствующую информацию лицам, указанным в п. 11 настоящих Условий.</p>
            <h2>17. Обращения пользователей</h2>
            <p>Оператор рассматривает обращения, связанные с настоящими Условиями, включая запросы пользователей относительно
        использования их персональных данных, с помощью формы обратной связи.
        Срок ответа на поступившие обращения составляет 10 рабочих дней с даты получения соответствующих запросов.
        Анонимные обращения не рассматриваются.
        Вся корреспонденция, направленная пользователями в адрес Оператора (письма в обычной или электронной форме)
        воспринимаются Оператором как информация ограниченного доступа и может быть опубликована только с письменного
        согласия пользователя, а адреса, персональные данные и иная информация о пользователях, направивших эти письма, не
        могут быть без специального их согласия использованы иначе, как для ответа по теме полученного обращения.
            </p>
            <h2>18. Доступ к Условиям
            </h2>
            <p>Настоящие Условия являются открытым и общедоступным документом. Действующая редакция доступна в Интернете по
        Интернет-ссылке размещенной по адресу:
            <a href={`https://${prefix}.wfm.rt.ru/privacy_policy/`}>https://{prefix}.wfm.rt.ru/privacy_policy/</a>.
        Оператор не ведет сбор информации о пользователях, связанный с доступом к данной интернет-странице.
            </p>
            <h2>19. Право Оператора на изменение Условий
            </h2>
            <p>Настоящая редакция Условий вступила в силу 1 мая 2021 года. Оператор сохраняет за собой право в любое время
        изменить положения настоящих Условий, уведомив об этом пользователей в Интернете по адресу, на котором размещены
        настоящие Условия. Редакции недействующих Условий хранятся в архиве документации Оператора.</p>
          </article>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPpolicy;

